import {constantFalse} from '@packages/utilities/fp/utils';

import * as w from '@packages/systems/wfdl';
import * as wq from '@packages/systems/wfdl-Qualified';

const composeVar = wq.qualify(
  wq.pluginName('Effect'),
  wq.identifier('compose')
);

export const isComposeExpressionVariable = w.matchExpression({
  Variable: w.Variable.match({
    qualified: (name) => wq.namesEqual(name, composeVar),
    unqualified: constantFalse,
  }),
  _: constantFalse,
});
